import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/uptownpokies/default.vue").then(m => m.default || m))
}